import Header from "@/components/Header";
import Hero from "@/components/Hero";
import MarketProblemSection from "@/components/MarketProblemSection";
import SecretWeaponSection from "@/components/SecretWeaponSection";
import ServicesSection from "@/components/ServicesSection";
import BattleSection from "@/components/BattleSection";
import SocialProofStats from "@/components/SocialProofStats";
import FeaturedDeals from "@/components/FeaturedDeals";
import AnalyticsPreview from "@/components/AnalyticsPreview";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <FeaturedDeals />
        <MarketProblemSection />
        <SecretWeaponSection />
        <ServicesSection />
        <BattleSection />
        <SocialProofStats />
        {/* <AnalyticsPreview /> */}
      </main>
      <Footer />
    </div>
  );
};

export default Index;
